import { useState, useEffect } from "react";
import { createModel } from "hox";
import { salesService } from "../../salesService";
import { ISalesTabEnum, ISalesDetailsAdded, ISalesDetailMethod, ISalesDetail, ISalesExamine, ISalesMaterialDetail, ISaleDescType, ISaleSettlement } from "../../salesTypes";
import { useGlobalModel } from "@/model/globalModel";
import { message } from "antd";
import { useLockFn } from "ahooks";
import { getRandomStr, formatInt, formatNum } from "@/utils/utils";
import { IMaterialDetail } from "@/views/base/material/materialService";
import moment from "moment";
import { ILogistics } from "@/views/shipment/shimentTypes";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { offerService } from "@/views/inquires/offer/offerService";
import { ISettleParams } from "@/views/public/publicService";
import { useDictModel } from "@/views/base/dict/dictModel";
import { create } from "lodash";


//初始加收费用
const initAdded: ISalesDetailsAdded = {
    key: "1",
    amount: "0",
    currencyAmount: "0", //币种金额
    ename: "",
    name: "",
}

//初始收汇方式
const initMethod: ISalesDetailMethod = {
    key: "1",
    amount: "0",
    around: "",
    certificatesTime: "",
    collectionTime: "",
    paymentMethod: "",
    paymentTime: "",
    proportion: "",
}


const initDesc = {
    numAll: 0,
    saleAmountAll: 0,
    tradeAmountAll: 0,
    addedAmountAll: 0
}

export const useSalesDetailModel = createModel(function () {
    const { user: { shopCode, shopName } } = useGlobalModel(({ user }) => [user]);
    const { getTreeNodeValue } = useDictModel();

    const initFormVal = {
        id: "",
        code: "",
        shopName,
        rmbAmount: "0",
        goodsAmount: "0",
        addAmount: "0",
        contractAmount: "0",
        exchangeRate: 1, //汇率默认1
    };
    const [tabActive, setTabActive] = useState<ISalesTabEnum>(ISalesTabEnum.BASE_DETAIL) //tabs 选中
    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<ISalesDetail>(initFormVal);
    const [editList, setEditList] = useState<ISalesMaterialDetail[]>([]);
    const [editAddedList, setEditAddedList] = useState<ISalesDetailsAdded[]>([initAdded]);
    const [editMethodList, setEditMethodList] = useState<ISalesDetailMethod[]>([initMethod]);
    const [editDesc, setEditDesc] = useState<ISaleDescType>(initDesc);
    //新增缓存
    const [addFormVal, setAddFormVal] = useState<ISalesDetail>(initFormVal);
    const [addList, setAddList] = useState<ISalesMaterialDetail[]>([]);
    const [addAddedList, setAddAddedList] = useState<ISalesDetailsAdded[]>([initAdded]);
    const [addMethodList, setAddMethodList] = useState<ISalesDetailMethod[]>([initMethod]);
    const [addDesc, setAddDesc] = useState<ISaleDescType>(initDesc);
    //添加商品弹框
    const [materialDialog, setMaterialDialog] = useState<boolean>(false);

    //计算商品总计， 和加收费用总计
    // contractAmount  //合同总金额  外贸价格总金额sum
    // rmbAmount  // 人民币金额 云湖总价合计sum
    // goodsAmount  // 人民币金额 云湖总价合计sum
    // addedAmount // 加收费用sum
    useEffect(() => {
        let newDesc: ISaleDescType = { ...initDesc };
        editList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.saleAmountAll += Number(item.saleAmount);
            newDesc.tradeAmountAll += Number(item.tradeAmount);
        });
        newDesc.addedAmountAll = editAddedList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0);
        setEditDesc(newDesc);
        updateFormVal("edit", {
            contractAmount: clauseChange("edit", editFormVal.clause ?? "", newDesc, editAddedList),
            rmbAmount: formatNum(newDesc.saleAmountAll),
            goodsAmount: formatNum(newDesc.tradeAmountAll),
            addAmount: formatNum(newDesc.addedAmountAll)
        });
    }, [editList, editAddedList])

    useEffect(() => {
        let newDesc: ISaleDescType = { ...initDesc };
        addList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.saleAmountAll += Number(item.saleAmount);
            newDesc.tradeAmountAll += Number(item.tradeAmount);
        });
        newDesc.addedAmountAll = addAddedList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0);
        setAddDesc(newDesc);
        updateFormVal("add", {
            contractAmount: clauseChange("add", addFormVal.clause ?? "", newDesc, addAddedList),
            rmbAmount: formatNum(newDesc.saleAmountAll),
            goodsAmount: formatNum(newDesc.tradeAmountAll),
            addAmount: formatNum(newDesc.addedAmountAll)
        });
    }, [addList, addAddedList])


    //汇率失焦
    const exchangeRateChange = (mode: string, exchangeRate: number) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        //修改外贸价格
        //外贸价格 = 云湖销售单价（人民币）/ 汇率
        // setList(origin => origin.map(item => {
        //     let tradePrice = +formatNum(+item.salePrice / +exchangeRate);
        //     return {
        //         ...item,
        //         tradePrice,
        //         tradeAmount: formatNum(+item.num * tradePrice),
        //     }
        // }))
    }

    //获取币种符号
    const getcurrencySymbol = (mode: string) => {
        let currencyCode: string | undefined = mode === "edit" ? editFormVal.currencyCode : addFormVal.currencyCode;
        if (!currencyCode) return ""
        return getTreeNodeValue(currencyCode);
    }

    //添加收汇方式
    const addMethod = (mode: string) => {
        const setMethodList = mode === "edit" ? setEditMethodList : setAddMethodList;
        setMethodList(origin => [...origin, {
            ...initMethod,
            amount: "0.00",
            proportion: "0.00%",
            key: getRandomStr()
        }])
    }

    //添加加收费用
    const addAdded = (mode: string) => {
        const setAddedList = mode === "edit" ? setEditAddedList : setAddAddedList;
        setAddedList(origin => [...origin, {
            ...initAdded,
            key: getRandomStr()
        }])
    }

    //重置页面缓存
    const resetPageCache = (mode: string) => {
        if (mode === "edit") {
            setEditFormVal(initFormVal);
            setEditList([]);
            setEditMethodList([])
        }
        else if (mode === "add") {
            setAddFormVal(initFormVal);
            setAddList([]);
            setAddMethodList([])
        }
        setTabActive(ISalesTabEnum.BASE_DETAIL);
    }

    //主单修改
    const updateFormVal = (mode: string, val?: object | null) => {
        const setFormVal = mode === "edit" ? setEditFormVal : setAddFormVal;
        setFormVal((origin: any) => val ? { ...origin, ...val } : initFormVal);
    }

    //商品子表修改
    const updateList = (mode: string, val: ISalesMaterialDetail[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList([...val]);
    }

    /**
      * 根据贸易条款的选择 返回计算好的合同总金额 
      * 金额计算 四种情况
      */
    const clauseChange = (mode: string, clasueVal: string, amountAll?: ISaleDescType, addedLists?: ISalesDetailsAdded[]): number => {
        const amounts = amountAll ? amountAll : (mode === "edit" ? editDesc : addDesc);  //附加费
        const addedList = addedLists ? addedLists : (mode === "edit" ? editAddedList : addAddedList);
        let contractAmount: number = 0;

        // 贸易条款  FOB  采购总金额sum
        if (clasueVal === DictCodeEnmu.TRADE_FOB) {
            contractAmount = amounts.tradeAmountAll;
        }
        // 贸易条款  CFR  采购总金额sum + 附加费（只取海运费） 
        else if (clasueVal === DictCodeEnmu.TRADE_CFR) {
            //查询是否存在海运费
            const hyAdded: ISalesDetailsAdded | undefined = addedList.find(item => (item.name ?? "").indexOf("海运费") > -1);
            //取到海运费
            const hyMoney: number = +(hyAdded?.amount ?? 0)
            contractAmount = amounts.tradeAmountAll + hyMoney;
        }
        // CLF  采购总金额sum + 附加费
        // else if (clasueVal === DictCodeEnmu.TRADE_CLF) {
        //     contractAmount = amounts.tradeAmountAll + amounts.addedAmountAll;
        // }
        // 默认 采购总金额sum + 附加费
        else {
            contractAmount = amounts.tradeAmountAll + amounts.addedAmountAll;
        };
        return +formatNum(contractAmount);
    }

    //商品子表添加
    const insertMaterial = (mode: string, arr: IMaterialDetail[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        const formVal: ISalesDetail = mode === "edit" ? editFormVal : addFormVal;
        setList(origin => {
            let newArr: ISalesMaterialDetail[] = [...origin];
            let { exchangeRate } = formVal;  //主单维护的所有单价上浮
            arr.forEach(material => {
                //选中的是否存在列表
                let isExist = origin.find(item => item.materialCode == material.code);
                if (!isExist) {
                    let num = +formatInt(material.num);
                    let salePrice = +formatNum(material.buyingPrice); //云湖单价
                    //外贸价格 = 云湖销售单价（人民币）/ 汇率
                    let tradePrice = +formatNum(salePrice / +exchangeRate);
                    newArr.push({
                        key: material.id,
                        "materialId": material.id,                  // "物料id",
                        "materialCode": material.code,                  // "物料编号",
                        "replaceCode": material.replaceCode,                  // "替换号",
                        "materialName": material.name,                  // "物料名称",
                        "materialEname": material.nameEn,                  // "物料名称英文",
                        "typeCode": material.typeCode,                  // "物料类型",
                        "typeName": material.typeName,                  // "物料类型名称",
                        "model": material.model,                  // "规格",
                        "unitCode": material.unitCode,
                        "unitName": material.unitName,
                        "num": num,
                        "salePrice": salePrice,
                        "saleAmount": +formatNum(num * salePrice),
                        "tradePrice": tradePrice,   // 外贸价格
                        "tradeAmount": +formatNum(num * tradePrice),   //外贸总价
                        "customsCode": material.customsCode,   // "海关编码", 
                        "note": "",   // "备注"
                    })
                }
            });
            return newArr;
        });
        setMaterialDialog(false);
    }

    //商品子表删除
    const removeMaterial = (mode: string, selectedRowKeys: string[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList(origin => origin.filter(item => selectedRowKeys.indexOf(item.key) < 0));
    }

    //获取一条数据
    const getSalesDetailOne = async (id: string) => {
        debugger
        let { retData } = await salesService.one(id);
        let { details, detailsAdd, detailsPayment, ...formVal } = retData;
        if (retData) {
            detailsAdd = detailsAdd ?? []
            detailsPayment = detailsPayment ?? []
            setEditFormVal({
                ...initFormVal,
                ...formVal,
                // createTime:  formVal.createTime ? moment(formVal.createTime).format("YYYY-MM-DD") : null,
	            // updateTime: formVal.updateTime ? moment(formVal.updateTime).format("YYYY-MM-DD") : null,
                createTime:formVal.createTime ?moment(formVal.createTime):null,
                updateTime:formVal.updateTime ?moment(formVal.updateTime):null,
                payTime:formVal.payTime ?moment(formVal.payTime):null,
                offerTime: formVal.offerTime ? moment(formVal.offerTime) : null,
                estimatedTime: (formVal.estimatedTime ? moment(formVal.estimatedTime) : null),
                shippingTime: (formVal.shippingTime ? moment(formVal.shippingTime) : null),
                termTime: formVal.termTime ? moment(formVal.termTime) : null,
                settlementTime: formVal.settlementTime ? moment(formVal.settlementTime) : null,
                batches: formVal.batches === "1" ? true : false, // "分批",
                transship: formVal.transship === "1" ? true : false, // "转船",
            });
            setEditList(details?.map(item => ({ ...item, key: item.id ?? "" })) ?? []);
            //加收费用  收汇方式  空初始一条数据
            setEditAddedList(detailsAdd.length > 0 ? detailsAdd.map(item => ({ ...item, key: item.id ?? "" })) : [initAdded]);
            setEditMethodList(detailsPayment.length > 0 ? detailsPayment.map(item => ({
                ...item,
                key: item.id ?? "",
                // paymentTime: item.paymentTime ? moment(item.paymentTime) : null,
                collectionTime: item.collectionTime ? moment(item.collectionTime) : null,
                certificatesTime: item.certificatesTime ? moment(item.certificatesTime) : null,
            })) : [initMethod]);
        }
        return retData;
    };

    //获取一条数据
    const getOfferDetail = async (id: string) => {
     debugger
        let { retData } = await offerService.one(id);
        let { details, detailsAdd, detailsPayment, ...formVal } = retData;
        if (retData) {
            detailsAdd = detailsAdd ?? []
            detailsPayment = detailsPayment ?? []
            let { id, updateTime, updateUser, status, ...newFormVal } = formVal;
            setAddFormVal({
                ...initFormVal,
                ...newFormVal,
                offerCode:formVal.code,
                offerRealCode:formVal.realCode,
                createTime:formVal.createTime ?moment(formVal.createTime):null,
                updateTime:formVal.updateTime ?moment(formVal.updateTime):null,
                offerTime: newFormVal.offerTime ? moment(newFormVal.offerTime) : null,
                termTime: newFormVal.termTime ? moment(newFormVal.termTime) : null,
                batches: newFormVal.batches === "1" ? true : false, // "分批",
                transship: newFormVal.transship === "1" ? true : false,// "转船",
               
            });
            setAddList(details?.map(item => {
                let { id, ...newItem } = item;
                return { ...newItem, key: item.id ?? "" }
            }) ?? []);
            //加收费用  收汇方式  空初始一条数据
            setAddAddedList(detailsAdd.length > 0 ? detailsAdd.map(item => ({ ...item, key: item.id ?? "", id: undefined })) : [initAdded]);
            setAddMethodList(detailsPayment.length > 0 ? detailsPayment.map(item => ({
                ...item,
                id: undefined,
                key: item.id ?? "",
                // paymentTime: item.paymentTime ? moment(item.paymentTime) : null,
                collectionTime: item.collectionTime ? moment(item.collectionTime) : null,
                certificatesTime: item.certificatesTime ? moment(item.certificatesTime) : null,
            })) : [initMethod]);
        }
        message.success("已带出此报价单的全部数据")
        return retData;
    };

  
   

    //报价单新增 | 编辑
    const insertOrUpdateSales = useLockFn(async (mode: string, formVal: ISalesDetail, refresh = true) => {
       // debugger
        const materialList = mode === "edit" ? editList : addList;
        const detailsAdd = mode === "edit" ? editAddedList : addAddedList;
        const detailsPayment = mode === "edit" ? editMethodList : addMethodList;
        const formV = mode === "edit" ? editFormVal : addFormVal;

        let data = {
            ...formV,
            ...formVal,
            shopCode,
            createTime: formVal.createTime instanceof Object ? formVal.createTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            updateTime: formVal.updateTime instanceof Object ? formVal.updateTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            offerTime: formVal.offerTime instanceof Object ? formVal.offerTime.format('YYYY-MM-DD HH:mm:ss') : null,
            payTime: formVal.payTime instanceof Object ? formVal.payTime.format('YYYY-MM-DD HH:mm:ss') : null,
            shippingTime: formVal.shippingTime instanceof Object ? formVal.shippingTime.format('YYYY-MM-DD HH:mm:ss') : null,
            settlementTime: formVal.settlementTime instanceof Object ? formVal.settlementTime.format('YYYY-MM-DD HH:mm:ss') : null,
            estimatedTime: formVal.estimatedTime instanceof Object ? formVal.estimatedTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            termTime: formVal.termTime instanceof Object ? formVal.termTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            batches: formVal.batches ? "1" : "0", // "分批",
            transship: formVal.transship ? "1" : "0", // "转船",
            details: materialList,
            detailsAdd,
            //收汇方式 处理日期
            detailsPayment: detailsPayment.map(item => ({
                ...item,
                // paymentTime: item.paymentTime instanceof Object ? item.paymentTime.format('YYYY-MM-DDTHH:mm:ss') : null,
                collectionTime: item.collectionTime instanceof Object ? item.collectionTime.format('YYYY-MM-DDTHH:mm:ss') : null,
                certificatesTime: item.certificatesTime instanceof Object ? item.certificatesTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            }))
        };
          //查询报价单号是否已开单
          let searchParam={
            shopCode,
            pageSize:9999,
			pageNum: 1
          }
          let { retData } = await salesService.page(searchParam);
          const { records } = retData;
          
          let list = records.filter(item=>{ return item.offerCode===formV.offerCode})
          if(list.length !==0 && mode==='add'){
            message.warning('该报价单已新增外贸合同,不可重复新增!')
            return false
          }
        //新增
        if (mode === "edit") {
            let { retData } = await salesService.update({ ...data, id: editFormVal.id, code: editFormVal.code ?? "" });
            refresh && getSalesDetailOne(editFormVal.code)
            refresh && message.success("编辑成功")
            return retData;
        } else {
            let { retData } = await salesService.insert(data);
            message.success("新增成功,自动转换至编辑详情页")
            return retData;
        }
    })




    //提交审核
    const submitSales = useLockFn(async (id: string) => {
        // //校验收汇方式的金额合计 === 主单的
        // const methodTotalAmount = editMethodList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0);
        // if (methodTotalAmount !== +(editFormVal?.contractAmount ?? 0)) {
        //     message.warning("收汇方式的金额合计与主单的合同总金额不一致，请修改后重新保存");
        //     return false
        // }
        let formRes = await insertOrUpdateSales("edit", editFormVal, false);
        let { retData } = await salesService.submitSales(editFormVal.code);
        getSalesDetailOne(editFormVal.code)
        message.success("提交审核成功");
        return retData;
    })
    //总监审核
    const examineManager = useLockFn(async (obj: ISalesExamine) => {
        let { retData } = await salesService.examineManager(obj);
        getSalesDetailOne(editFormVal.code)
        message.success("已提交总监审核");
        return retData;
    })
    //财务审核
    const examineReckoner = useLockFn(async (obj: ISalesExamine) => {
        let { retData } = await salesService.examineReckoner(obj);
        getSalesDetailOne(editFormVal.code)
        message.success("已提交财务审核");
        return retData;
    })

    //出库
    const whConfirm = useLockFn(async () => {
        let { retData } = await salesService.whConfirm({
            shopCode,
            code: editFormVal.code
        });
        getSalesDetailOne(editFormVal.code)
        message.success("出库成功");
        return retData;
    })

    //发运
    const transferShipping = useLockFn(async () => {
        let { retData } = await salesService.transferShipping({
            shopCode,
            code: editFormVal.code
        });
        // getSalesDetailOne(editFormVal.code)
        message.success("发运成功,自动转换到出运详情页");
        return retData;
    })
    //转采购合同
    const transferPurchase = useLockFn(async () => {
        let { retData } = await salesService.transferPurchase({
            shopCode,
            code: editFormVal.code
        });
        message.success("转采购合同成功,自动转接到采购合同列表");
        return retData;
    })
    //转报关单据
    const transferCustoms = useLockFn(async () => {
        let { retData } = await salesService.transferCustoms({
            shopCode,
            code: editFormVal.code
        });
        message.success("转报关单据成功,自动转接到报关单列表");
        return retData;
    })
    /**
   * 物流进程
   */
    const [logFormVal, setLogFormVal] = useState<ILogistics>({});

    const getLogOne = async () => {
        let { retData } = await salesService.oneLog(editFormVal.code);
        setLogFormVal(retData ?? {});
        return retData;
    };

    /**
     * 结算
     */
    const [settleVisible, setSettleVisible] = useState<boolean>(false);   //收汇结算弹框
    const [settlementVisible, setSettlementVisible] = useState<boolean>(false);   //结汇结算弹框

    const saleSettle = useLockFn(async (val: ISettleParams) => {
        let data: ISettleParams = {
            ...val,
            shopCode,
        };
        // debugger;
        let { retData, retMsg } = await salesService.settle(data);
        if (retData) {
            message.success("结算成功")
            setSettleVisible(false);
            getSalesDetailOne(editFormVal.code)
        } else {
            message.warning(retMsg)
        }
    });


    //收汇、结汇
    const receiptSettle = useLockFn(async (data: ISaleSettlement[], ioFlag = 0) => {
        let { retData } = await salesService.receiptSettle(data);
        //保存的时候生成结算时间payTime
        let params = {
            ...editFormVal,
            payTime: moment().format("YYYY-MM-DD HH:mm:ss"),
            shopCode,
            offerTime: editFormVal.offerTime instanceof Object ? editFormVal.offerTime.format('YYYY-MM-DD HH:mm:ss') : null,
            estimatedTime: editFormVal.estimatedTime instanceof Object ? editFormVal.estimatedTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            termTime: editFormVal.termTime instanceof Object ? editFormVal.termTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            batches: editFormVal.batches ? "1" : "0", // "分批",
            transship: editFormVal.transship ? "1" : "0", // "转船",
            details: editList,
            detailsAdd: editAddedList,
            //收汇方式 处理日期
            detailsPayment: editMethodList.map(item => ({
                ...item,
                collectionTime: item.collectionTime instanceof Object ? item.collectionTime.format('YYYY-MM-DDTHH:mm:ss') : null,
                certificatesTime: item.certificatesTime instanceof Object ? item.certificatesTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            }))
        };
        // let { retData: formData } = await salesService.update(params);
        if (retData) {
            message.success("保存成功")
            ioFlag ? setSettlementVisible(false) : setSettleVisible(false);
            getSalesDetailOne(editFormVal.code)
        }
        return retData;
    });

    //收汇已完结
    const settleStatu = useLockFn(async () => {
        let { retData } = await salesService.settleStatu(editFormVal.code);
        message.success("收汇成功")
        setSettleVisible(false);
        getSalesDetailOne(editFormVal.code)
    });

    //结汇完结
    const settlementStatu = useLockFn(async () => {
        let { retData } = await salesService.settlementStatu(editFormVal.code);
        message.success("结汇成功")
        setSettlementVisible(false);
        getSalesDetailOne(editFormVal.code)
    });

    return {
        /***field***/
        editFormVal,
        editList,
        addFormVal,
        addList,
        initAdded,
        initMethod,
        addDesc,
        editDesc,
        tabActive, setTabActive,
        materialDialog, setMaterialDialog,
        editMethodList, setEditMethodList,
        editAddedList, setEditAddedList,
        addMethodList, setAddMethodList,
        addAddedList, setAddAddedList,
        /***method***/
        getSalesDetailOne, submitSales, examineManager, examineReckoner,
        updateFormVal,
        updateList,
        removeMaterial,
        insertMaterial,
        insertOrUpdateSales,
        resetPageCache,
        addMethod,
        addAdded,
        whConfirm,
        transferShipping,
        exchangeRateChange,
        clauseChange,
        transferPurchase,
        getcurrencySymbol,
        //**************** */
        logFormVal, setLogFormVal,
        getLogOne, getOfferDetail, saleSettle,
        settleVisible, setSettleVisible,
        settlementVisible, setSettlementVisible,
        receiptSettle, settleStatu, settlementStatu,
        transferCustoms
    }
});